import { useRouter } from 'next/router';

import { Box, BoxProps } from '@chakra-ui/react';

import { TypeArea, TypeCity } from 'generated/contentful';

import { Formik } from 'formik';

import { RECRUIT_PATH_PREFIX } from 'common/constants';

import { validationSchema } from './JobsBoard.schema';
import JobsBoardAdvert, { JobsBoardAdvertProps } from './JobsBoardAdvert';
import JobsBoardSearchForm from './JobsBoardSearchForm';

interface JobsBoardProps {
  city: TypeCity<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  cities: TypeCity<'WITHOUT_UNRESOLVABLE_LINKS', string>[];
  area?: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>;
  areas: TypeArea<'WITHOUT_UNRESOLVABLE_LINKS', string>[];
  items: JobsBoardAdvertProps[];
}

export default function JobsBoard({ city, cities, area, areas, items, ...boxProps }: JobsBoardProps & BoxProps) {
  const router = useRouter();

  return (
    <Box {...boxProps}>
      <Formik
        initialValues={{
          city: city.fields.slug,
          area: area ? area.fields.slug : null
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true);
          if (!values.area) {
            await router.push(`${RECRUIT_PATH_PREFIX}/jobs/${values.city}/`);
          } else {
            await router.push(`${RECRUIT_PATH_PREFIX}/jobs/${values.city}/${values.area}/`);
          }
        }}
      >
        <JobsBoardSearchForm city={city} cities={cities} area={area} areas={areas} mb={10} />
      </Formik>

      {items.map((itemProps, index) => {
        return <JobsBoardAdvert {...itemProps} key={index} />;
      })}
    </Box>
  );
}
